import { fetchJSON } from './api';
import { apiPath } from './constants';

export interface ActionLabel {
  start_second: number;
  final_text: string;
  final_text_zh: string | null;
  source: 'llm' | 'llm_wrote_own' | 'manual';
  selected_index: number | null;
  candidates_json: string | null; // JSON of {en: string, zh: string}[]
  model: string | null;
  llm_duration_s: number | null;
  updated_by: string;
  updated_at_ms: number;
}

export interface SaveActionLabelPayload {
  final_text: string;
  final_text_zh: string | null;
  source: ActionLabel['source'];
  selected_index: number | null;
  candidates_json: string | null;
  model: string | null;
  llm_duration_s: number | null;
  updated_by: string;
}

export async function fetchActionLabels(episodeId: string): Promise<ActionLabel[]> {
  const url = apiPath(`/episode/${encodeURIComponent(episodeId)}/action-labels`);
  const result = await fetchJSON<{ labels: ActionLabel[] }>(url);
  return result?.labels ?? [];
}

export async function saveActionLabel(
  episodeId: string,
  startSecond: number,
  payload: SaveActionLabelPayload
): Promise<ActionLabel> {
  const url = apiPath(`/episode/${encodeURIComponent(episodeId)}/action-labels/${startSecond}`);
  const result = await fetchJSON<ActionLabel>(url, {
    method: 'PUT',
    json: payload,
  });
  if (!result) throw new Error('No response from saveActionLabel');
  return result;
}

export async function deleteActionLabel(episodeId: string, startSecond: number): Promise<void> {
  const url = apiPath(`/episode/${encodeURIComponent(episodeId)}/action-labels/${startSecond}`);
  await fetchJSON<void>(url, { method: 'DELETE' });
}
